import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from "react-router-dom";
import Header from './component/Header';
import Home from './component/Home';
import Shop from './component/Shop';
import Footer from './component/Footer';
import Product from './component/Product';

function App() {
  return (
    <>
    <Header />
    <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="shop" element={<Shop />}/>
      <Route path="product" element={<Product />}/>
    </Routes>
    <Footer />
    </>
  );
}

export default App;
